import * as Env from '../constants/env'

export default {
  GET_PROFILES_LIST_URL: `${Env.PROFILE_HOST}/resource/profile/registry.json`,

  REQUEST_PROFILE_DATA: 'REQUEST_PROFILE_DATA',
  RECEIVE_PROFILE_DATA: 'RECEIVE_PROFILE_DATA',
  FILTER_PROFILE_DATA: 'FILTER_PROFILE_DATA',
  SORT_PROFILE_DATA: 'SORT_PROFILE_DATA',
  SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
  RESET_ERROR_MESSAGE: 'RESET_ERROR_MESSAGE',
}



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/